import { useState, useEffect } from 'react';
import { contentfulClient } from '../lib/contentful';

export function useBlogPost(slug) {
    const [post, setPost] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      async function fetchPost() {
        try {
          const response = await contentfulClient.getEntries({
            content_type: 'blogPost',
            'fields.slug': slug,
            limit: 1,
          });
          
          if (!response.items.length) {
            console.warn('No post found with slug:', slug);
            setPost(null);
          }
  
          const mainPost = response.items[0];
          const relatedSlugs = mainPost.fields.relatedPosts?.map(post => post.fields.slug) || [];
  
          // If there are related posts, fetch them
          let relatedPostsData = {};
          if (relatedSlugs.length > 0) {
            const relatedResponse = await contentfulClient.getEntries({
              content_type: 'blogPost',
              'fields.slug[in]': relatedSlugs.join(','),
            });
  
            relatedPostsData = relatedResponse.items.reduce((acc, item) => ({
              ...acc,
              [item.fields.slug]: {
                title: item.fields.title,
                excerpt: item.fields.excerpt,
                coverImage: item.fields.coverImage?.fields?.file?.url 
                  ? `https:${item.fields.coverImage.fields.file.url}` 
                  : ''
              }
            }), {});
          }
  
          const formattedPost = {
            slug: mainPost.fields.slug,
            title: mainPost.fields.title,
            excerpt: mainPost.fields.excerpt,
            coverImage: mainPost.fields.coverImage?.fields?.file?.url 
              ? `https:${mainPost.fields.coverImage.fields.file.url}` 
              : '',
            date: mainPost.fields.publishDate,
            author: mainPost.fields.author,
            content: mainPost.fields.content || {},
            seoDescription: mainPost.fields.seoDescription,
            tags: Array.isArray(mainPost.fields.tags) 
              ? mainPost.fields.tags 
              : JSON.parse(mainPost.fields.tags || '[]'),
            relatedPosts: relatedSlugs,
            relatedPostsData
          };
  
          setPost(formattedPost);
        } catch (err) {
          console.error('Error fetching post:', err);
          setError(err);
        } finally {
          setIsLoading(false);
        }
      }
  
      if (slug) {
        fetchPost();
      }
    }, [slug]); // Now we only depend on slug
  
    return { post, isLoading, error };
  }